module.exports = __webpack_public_path__ + "img/weather_06.9c99c6bc.png";